import { render, staticRenderFns } from "./SharedEnquiryClassic.vue?vue&type=template&id=6ad3c198&scoped=true"
import script from "./SharedEnquiryClassic.vue?vue&type=script&lang=js"
export * from "./SharedEnquiryClassic.vue?vue&type=script&lang=js"
import style0 from "./SharedEnquiryClassic.vue?vue&type=style&index=0&id=6ad3c198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3c198",
  null
  
)

export default component.exports